(() => {
  const root = document.documentElement;
  const body = document.body;
  if (!body?.hasAttribute('data-ascc-neomotion')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(pointer: fine)');
  const readPreference = () => {
    try { return sessionStorage.getItem('asccMotion'); } catch { return null; }
  };
  const writePreference = (value) => {
    try { sessionStorage.setItem('asccMotion', value); } catch {}
  };

  const storedPreference = readPreference();
  const shouldStartOff = storedPreference === 'off' || (storedPreference === null && reduceMotion.matches);
  body.dataset.asccMotion = shouldStartOff ? 'off' : 'on';

  const toggle = document.getElementById('AsccMotionToggle');
  const heroVideos = [...document.querySelectorAll('[data-ascc-hero-video], .ascc-bg-video__video')];

  heroVideos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.addEventListener('error', () => {
      video.closest('.ascc-bg-video')?.classList.add('ascc-bg-video--video-error');
    }, { once: true });
  });

  const setRevealVisible = () => {
    document.querySelectorAll('[data-ascc-reveal]').forEach((element) => element.classList.add('is-visible'));
  };

  const syncVideos = () => {
    const motionOff = body.dataset.asccMotion === 'off';
    heroVideos.forEach((video) => {
      if (motionOff || document.hidden) {
        video.pause();
        return;
      }
      const playPromise = video.play();
      if (playPromise?.catch) playPromise.catch(() => {});
    });
  };

  const updateToggle = () => {
    if (!toggle) return;
    const motionOff = body.dataset.asccMotion === 'off';
    toggle.textContent = motionOff ? 'Enable motion' : 'Reduce motion';
    toggle.setAttribute('aria-pressed', String(motionOff));
  };

  updateToggle();
  syncVideos();

  toggle?.addEventListener('click', () => {
    const next = body.dataset.asccMotion === 'off' ? 'on' : 'off';
    body.dataset.asccMotion = next;
    writePreference(next);
    updateToggle();
    syncVideos();
    if (next === 'off') setRevealVisible();
  });

  if (finePointer.matches) {
    window.addEventListener('pointermove', (event) => {
      if (body.dataset.asccMotion === 'off') return;
      root.style.setProperty('--ascc-x', `${event.clientX}px`);
      root.style.setProperty('--ascc-y', `${event.clientY}px`);
    }, { passive: true });
  }

  const revealElements = [...document.querySelectorAll('[data-ascc-reveal]')];
  if ('IntersectionObserver' in window && body.dataset.asccMotion !== 'off') {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    revealElements.forEach((element) => observer.observe(element));
  } else {
    setRevealVisible();
  }

  const followSystemPreference = () => {
    if (readPreference() !== null) return;
    body.dataset.asccMotion = reduceMotion.matches ? 'off' : 'on';
    updateToggle();
    syncVideos();
    if (reduceMotion.matches) setRevealVisible();
  };

  document.addEventListener('visibilitychange', syncVideos);

  if (typeof reduceMotion.addEventListener === 'function') {
    reduceMotion.addEventListener('change', followSystemPreference);
  }
})();